import { Flex, Text, useModal, Box, Balance, Pool, BaseButtonProps, Button, FlexGap } from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'
import { getBalanceNumber } from '@pancakeswap/utils/formatBalance'
import { Flexible2Locked, IsLocked, VaultKey } from 'state/types'
import { useVaultPoolByKey } from 'state/pools/hooks'
import { Token } from '@pancakeswap/sdk'
import { useTranslation } from '@pancakeswap/localization'
import styled from 'styled-components'
// import { secondsToDay } from 'utils/timeHelper'
// import { secondsToHours } from 'date-fns'
import useWithdrawalFeeTimer from 'views/Pools/hooks/useWithdrawalFeeTimer'
import useBUSDPrice from 'hooks/useBUSDPrice'
import NotEnoughTokensModal from '../../Modals/NotEnoughTokensModal'
import VaultStakeModal from '../VaultStakeModal'
import ConvertToLock from '../../LockedPool/Common/ConvertToLock'
import WithdrawalFeeTimer from '../WithdrawalFeeTimer'

interface HasStakeActionProps {
  pool: Pool.DeserializedPool<Token>
  stakingTokenBalance: BigNumber
  performanceFee: number
}

const HasSharesActions: React.FC<React.PropsWithChildren<HasStakeActionProps>> = ({
  pool,
  stakingTokenBalance,
  performanceFee,
}) => {
  const {
    userData: {
      lastUserActionAmount,
      balance: { cakeAsBigNumber, cakeAsNumberBalance },
    },
  } = useVaultPoolByKey(pool.vaultKey)

  const { t } = useTranslation()

  const { stakingTokenPrice, stakingToken } = pool

  const stakingTokenPriceUSD = useBUSDPrice(stakingToken)

  const {
    userData: { lastDepositedTime, userShares },
    fees: { withdrawalFee, withdrawalFeePeriod },
  } = useVaultPoolByKey(pool.vaultKey)

  const isCakeVault = Flexible2Locked(pool.vaultKey)===VaultKey.CakeVault
  const stakedVaultAmount = isCakeVault ? cakeAsBigNumber : lastUserActionAmount
  const stakedVaultBalance = getBalanceNumber(stakedVaultAmount, stakingToken.decimals)
  const stakedVaultBalanceUSD = getBalanceNumber(
    stakedVaultAmount.multipliedBy(stakingTokenPrice ?? stakingTokenPriceUSD?.toFixed(stakingToken.decimals)),
    stakingToken.decimals,
  )

  const feeAsDecimal = withdrawalFee / 100 || undefined
  // const withdrawalDayPeriod = withdrawalFeePeriod ? secondsToDay(withdrawalFeePeriod) : '-'
  // const withdrawalFeePeriodHour = withdrawalFeePeriod ? secondsToHours(withdrawalFeePeriod) : '-'
  const { secondsRemaining, hasUnstakingFee } = useWithdrawalFeeTimer(
    parseInt(lastDepositedTime, 10),
    userShares,
    withdrawalFeePeriod,
  )

  // The user has made a deposit, but has no fee
  const noFeeToPay = lastDepositedTime && !hasUnstakingFee && userShares.gt(0)
  
  // const cakePriceBusd = usePriceCakeBusd()
  // const stakedDollarValue = cakePriceBusd.gt(0)
  //   ? getBalanceNumber(cakeAsBigNumber.multipliedBy(cakePriceBusd), stakingToken.decimals)
  //   : 0

  const [onPresentTokenRequired] = useModal(<NotEnoughTokensModal tokenSymbol={stakingToken.symbol} />)
  const [onPresentStake] = useModal(
    <VaultStakeModal stakingMax={stakingTokenBalance} performanceFee={performanceFee} pool={pool} />,
  )
  const [onPresentUnstake] = useModal(
    <VaultStakeModal stakingMax={stakedVaultAmount} pool={pool} isRemovingStake />,
    true,
    true,
    `withdraw-vault-${pool.sousId}-${pool.vaultKey}`,
  )

  const IconButton = styled(Button)<BaseButtonProps>`
    padding: 0;
    background:transparent;
  `;

  return (
    <>
      <FlexGap pb="16px" justifyContent="space-between" alignItems="center" gap="5px">
        <Flex flexDirection="column">
          <Text
            color="textSubtle"
            textTransform="uppercase"
            bold
            fontSize="12px"
          >
            {stakingToken.symbol}{' '}{t('Staked')}
          </Text>
          <Balance fontSize="20px" bold value={stakedVaultBalance} decimals={2} />
          <Text as={Flex} fontSize="12px" color="textSubtle" flexWrap="wrap">
            <Balance
              value={stakedVaultBalanceUSD}
              fontSize="12px"
              color="textSubtle"
              decimals={2}
              prefix="~"
              unit=" USD"
            />
          </Text>
        </Flex>
        {
          !noFeeToPay &&
          <Flex flexDirection="column">
            <Text
              color="textSubtle"
              textTransform="uppercase"
              bold
              fontSize="12px"
            >
              Unstaking Fee
            </Text>
            {
              feeAsDecimal
              ? <Balance fontSize="20px" bold value={feeAsDecimal} decimals={1} unit="%" />
              : <Text size="20px" bold>-</Text>
            }
            <Text as={FlexGap} fontSize="12px" color="textSubtle" flexWrap="nowrap">
              {t('Before')}
              &nbsp;
              <WithdrawalFeeTimer secondsRemaining={secondsRemaining} />
            </Text>
          </Flex>
        }
      </FlexGap>
      <FlexGap flex="1 1 0px" gap="8px">
        <IconButton
          width="100%"
          variant="secondary"
          onClick={() => {
            onPresentUnstake()
          }}
        >
          {/* <MinusIcon color="primary" width="24px" /> */}
          Pull out
        </IconButton>
        <IconButton 
          variant="secondary" 
          width="100%"
          onClick={stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired}>
          {/* <AddIcon color="primary" width="24px" height="24px" /> */}
          Insert
        </IconButton>
      </FlexGap>
      {IsLocked(pool.vaultKey) && (
        <Box mt="16px">
          <ConvertToLock pool={pool} stakingToken={stakingToken} currentStakedAmount={cakeAsNumberBalance} />
        </Box>
      )} 
    </>
  )
}

export default HasSharesActions
